const SgiFormFileEO = function () {
    return {
        alwBlk: true,
        btnN: "上传文件", // 按钮名称
        ctlN: "文件",
        // c:"desId",
        cluW: 150, // 按钮宽度
        ctlH: 0,
        ctlW: 24,
        desId: "EP_EO_UI_3118",
        iconPh: "upload", // 按钮图标
        // inpPopTe:"输入提示",
        isDis: false,
        isHdn: false,
        lblW: 6,
        mulSel: true, // 设置是否允许多选
        disType: "text",//上传文件列表样式

        // closeI:"SD_RP_IR_0001`UI`UI05", // 关闭按钮图标
        // fileNameI:"SD_RP_IR_0001`UI`UI03", // 文件图标
        // isLbl:false,
        // isRead:false,
        lblAlg: "right",
        // msfTgt:"qtip",


        // isGw:false,
        // isSrp:true,
        // maxL:20,
        // minL:0,
        // n:"描述GUID",
        // sNo:10,
        // t:"uploadFile",
        te: "上传文件",
        // useTim:0,
        // visible:true,
        // x:"0",
        // y:"0",
    }
}

export { SgiFormFileEO };
export default SgiFormFileEO;



// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiFormFileEO.js